<ng-container *transloco="let t">
  @if (label()) {
  <div [class]="labelClass()">
    <label [for]="controlId()" class="text-xs font-medium text-ink tracking-tight">
      {{ t(label()) }} @if (!disabled() && required()) {
      <span class="text-danger" aria-hidden="true"> *</span>
      }
    </label>
  </div>
  }

  <div class="flex items-stretch" dir="ltr">
    <juno-libs-ui-phone-number-country-picker
      [value]="countryCode()"
      (valueChange)="updateCountry($event)"
      (touch)="touch.emit()"
      [disabled]="disabled()"
      [pending]="pending()"
      [name]="controlId() + '-country'"
      ariaLabel="COUNTRY_CODE"
    />

    <div class="juno-phone-number__input-wrapper" [class.input-error]="showError()" [class.disabled]="disabled()">
      @if (selectedCountry()) {
      <span class="juno-phone-number__isd-prefix" aria-hidden="true"> +{{ selectedCountry()!.isdCode }} </span>
      }

      <input
        type="tel"
        [id]="controlId()"
        [name]="controlId()"
        [value]="phoneNumberText()"
        [disabled]="disabled()"
        [readonly]="pending()"
        [placeholder]="selectedCountry() ? '' : t('PHONE_NUMBER')"
        [class.disabled]="disabled()"
        [attr.aria-label]="label() ? null : t(ariaLabel()) || null"
        [attr.aria-required]="required()"
        [attr.aria-invalid]="showError()"
        [attr.aria-describedby]="showError() ? controlId() + '-error' : null"
        class="juno-phone-number__input"
        (input)="onPhoneInput($event)"
        (blur)="onPhoneBlur()"
      />
    </div>
  </div>

  @if (showError()) {
  <div [id]="controlId() + '-error'" role="alert">
    <juno-libs-ui-error [errors]="errors()"></juno-libs-ui-error>
  </div>
  }
</ng-container>
